import { SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_50 } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
import { getMargins } from '@oneaudi/unified-web-alpha-common';
import {} from './index.js';
export const StyledTagGroup = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.size === 'md' ? SYS_SPACE_FIXED_100 : SYS_SPACE_FIXED_50};
  align-items: flex-start;
  flex-flow: wrap;
`;
//# sourceMappingURL=index.styles.js.map